import { Wizard } from '../../../../../../core/wizard/wizard';
import { SalesVolumeRangeFilterDialogComponent } from './sales-volume-range-filter-dialog.component';

export class SalesVolumeRangeFilterWizard extends Wizard<any> {
  key = 'sales-volume-range-filter-wizard';
  pageTypeMap = {
    'sales-volume-range-filter': SalesVolumeRangeFilterDialogComponent
  };
  startingPageKey = 'sales-volume-range-filter';
  hideHeader = true;
  hideFooter = true;
  backgroundColor = '#111827';
  height = '85vh';
  maxHeight = '85vh';

  constructor() {
    super();
    this.width = 900;
  }
}
